<div
  #playerContainer
  id="{{ videoId }}"
  class="relative"
  [ngClass]="{
    'hide-controls': !this.playerConfig?.controls,
    'hide-play': !this.playerConfig?.tapcontrols,
    'no-border-radius': !this.borderRadius
  }"
></div>
<!-- used template to append it to #playerContainer after the video in order to be able to query the template from css-->
<template>
  <a
    #nextMomentTpl
    [class.hide]="!isNumber(nextMoment) || nextMoment === null || nextMoment < 0"
    (click)="onNextMoment.emit()"
    class="next-moment-container flex justify-center cursor-pointer"
  >
    <img class="img-desktop" src="/assets/images/svg/icons/video/player-icons/next-moment.svg" alt="Next moment" />
    <img
      class="img-mobile"
      src="/assets/images/svg/icons/video/player-icons/next-moment-mobile.svg"
      alt="Next moment"
    />
  </a>
  <a
    #prevMomentTpl
    [class.hide]="!isNumber(prevMoment) || prevMoment === null || prevMoment < 0"
    (click)="onPrevMoment.emit()"
    class="prev-moment-container flex justify-center cursor-pointer"
  >
    <img class="img-desktop" src="/assets/images/svg/icons/video/player-icons/prev-moment.svg" alt="Prev moment" />
    <img
      class="img-mobile"
      src="/assets/images/svg/icons/video/player-icons/prev-moment-mobile.svg"
      alt="Prev moment"
    />
  </a>
</template>
